module.exports = __webpack_public_path__ + "static/img/1_6.8369b6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/1_6.png
// module id = /kr1
// module chunks = 44